export default "__VITE_ASSET__15faf390__"